<div class="container mt-5">
  <h2 class="text-primary mb-4">الشركات </h2>

  <p>
    البحث 
  </p>
  <!-- Search Form -->
  <form (ngSubmit)="onSearch()" class="mb-4">
    <div class="d-flex gap-2">
      <input
        type="text"
        class="form-control"
        placeholder="رقم التجسيل"
        [(ngModel)]="registrationNumber"
        name="registrationNumber"
      />

      <input
        type="number"
        class="form-control"
        placeholder="الرقم الوطني للمنشأة"
        [(ngModel)]="companyNationalNumber"
        name="companyNationalNumber"
      />

      <button type="submit" class="btn btn-primary">Search</button>
      <button class="btn btn-secondary" type="button" (click)="clearForm()">Clear</button>
    </div>
  </form>

  <hr>

  <!-- Reactive Form -->

  <form [formGroup]="activityForm" (ngSubmit)="save()">
    <div class="row g-3">
      <div class="col-md-4" *ngFor="let field of fields">
        <label class="form-label">{{ field.label }}</label>
        <input
          type="{{field.controlType=='Date'?'date':'text'}}"
          class="form-control"
          [formControlName]="field.control"
          [class.is-invalid]="
            activityForm.get(field.control)?.touched &&
            activityForm.get(field.control)?.invalid
          "
        />
        <div
          class="invalid-feedback"
          *ngIf="
            activityForm.get(field.control)?.touched &&
            activityForm.get(field.control)?.invalid
          "
        >
          هذا الحقل مطلوب / This field is required
        </div>
      </div>
    </div>

    <div class="mt-4 text-end">
     <button type="submit" class="btn btn-primary">
        Save
    </button>
    </div>
  </form>
</div>

<br>
<br>
<br>
<br>